import { useState } from "react"
import useAxios from "./useAxios";
import { config } from "../config";
import { useParams } from "react-router-dom";

export default function useBusinessDetails(profile: any, setStep: any, setProfile: any) {
    const { id } = useParams<{ id: string }>();
    const axios = useAxios();
    const [errmsg, setErrmsg] = useState('')
    const [saving, setSaving] = useState(false);
    let t = {
        businessName: '', businessType: '', doingBusinessAs: '', website: '',
        phone: '', mcc: '', addressLine1: '', addressLine2: '', city: '', state: '',
        country: 'USA', zipcode: '', businessDescription: '', ein: '', email: '', incorporationDate: '', ...profile?.businessDetails
    }
    const [formData, setFormData] = useState(sanitizeObjectFields(t))

    function sanitizeObjectFields(obj: any) {
        for (let key in obj) {
            if (obj[key] === null || obj[key] === undefined) {
                obj[key] = '';
            }
        }
        return obj;
    }

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        let oldBusinessDetails = formData
        let newBusinessDetails = { ...oldBusinessDetails, [name]: value }
        setFormData(newBusinessDetails)
    };

    const handleNext = async () => {
        try {
            setSaving(true);
            setErrmsg('');
            const newProfile = { ...profile, businessDetails: formData };
            await axios.post(`${config.backendUrl}/accounts/onboarding-forms/${id}/`, newProfile);
            setProfile(newProfile);
            setStep((prev: number) => prev + 1);
        } catch (err: any) {
            console.error(err);
            setErrmsg(err.response?.data?.message || 'An error occurred while saving');
        } finally {
            setSaving(false);
        }
    }

    function generateMccOptions(mccCodes: any) {
        let options = []
        options.push({ value: '', label: 'Select your merchant category' })
        for (let item of mccCodes) {
            let option = { value: item.code, label: item.code + ": " + item.description }
            options.push(option)
        }
        return options
    }

    function generateCompanyTypeOptions() {
        let options = [
            { value: '', label: 'Select your business type' },
            { value: 'limited_liability_company', label: 'Limited Liability Company' },
            { value: 'corporation', label: 'Corporation' }
        ]
        return options
    }

    return { handleInputChange, handleNext, generateMccOptions, generateCompanyTypeOptions, formData, errmsg, saving }
}

